import React, { lazy } from "react";
import CreateEmployeeGG1 from "../Components/CGITrackingNew/CreateEmployeeGG1";
import LoadingDashboard from "../Components/Dashboard/Default/LoadingDashboard";
import { SilentRenewComponent } from "../SilentRenewComponent";
import TimesheetMain from "../Components/Timesheet/TimesheetMain";
import ActivityList from "../Components/Activity/ActivityList";
import NPAVIEWPrint from "../Components/PopUp/NPAVIEWPrint";
import NPADirectPrintSalaryIncrement from "../Components/PopUp/NPADirectPrintSalaryIncrement";
import PerformanceEvalutionList from "../Components/performanceEvaluation/PerformanceEvalutionList";
import AllEarnings from "../Components/EmployeeEarningsStatement/AllEarnings/AllEarnings";

const BottleNeckAnalysis = lazy(() =>
  import("../Components/Charts/BottleNeckAnalysis")
);
const SideBar = lazy(() => import("../Components/Sidebar/Index"));
const CreateMenu = lazy(() => import("../Components/Sidebar/CreateMenu"));

const IndividualDevelopmentPlan = lazy(() =>
  import("../Components/performanceEvaluation/IndividualDevelopmentPlan")
);
const WorkPlanning = lazy(() =>
  import("../Components/performanceEvaluation/WorkPlanning")
);

const UnAuthorized = lazy(() => import("../Components/UnAuthorized"));
const WithoutLogin = lazy(() => import("../Components/WithoutLogin"));
const Logout = lazy(() => import("../Components/Logout/index"));
const MainMenu = lazy(() => import("../Components/MainMenu/index"));
// dashbaord

const Ecommerce = lazy(() => import("../Components/Dashboard/Ecommerce"));
const Employee = lazy(() => import("../Components/Dashboard/Employee"));
const TransactionLogs = lazy(() => import("../Components/TransactionLog"));
const TransactionLogDetails = lazy(() =>
  import("../Components/TransactionLog/details")
);

const ChatAppContain = lazy(() => import("../Components/Chat/ChatApp"));
const LeaveShare = lazy(() =>
  import("../Components/Leave/leaveShare/leaveShare")
);
const LeaveShareManagement = lazy(() =>
  import("../Components/LeaveShareManagement")
);
const RecipientForm = lazy(() =>
  import("../Components/LeaveShareManagement/components/ReceipientForm")
);
const SearchRecipientDonor = lazy(() =>
  import("../Components/LeaveShareManagement/components/SelectRecipient")
);
const RequestedRecipient = lazy(() =>
  import("../Components/LeaveShareManagement/components/RequestedRecipient")
);
const LeaveApplicationWithFormik = lazy(() =>
  import("../Components/Leave/LeaveApplication")
);
const EmployeeVerificationList = lazy(() =>
  import("../Components/EmployeeVerification/index")
);
const EmployeeDigitalSignatureMgmt = lazy(() =>
  import("../Components/EmployeeDigitalSignatureMgmt")
);
const OutsideEmploymentWithFormik = lazy(() =>
  import("../Components/OutsideEmployment")
);
const EmployeeVerification = lazy(() =>
  import("../Components/EmployeeVarification")
);
const EmployeeEarning = lazy(() =>
  import("../Components/EmployeeEarningsStatement/Index")
);
const PerformanceEvaluation = lazy(() =>
  import("../Components/performanceEvaluation/performanceEvaluation")
);
const OnlineRecruitment = lazy(() =>
  import("../Components/online-recruitment/online-recruitment")
);
const RecruitmentFormData = lazy(() =>
  import("../Components/online-recruitment/component/recruitment-form")
);
const JobApplicationFormData = lazy(() =>
  import("../Components/online-recruitment/component/jobApplicationForm")
);
const MyApplications = lazy(() =>
  import("../Components/online-recruitment/component/myapplications")
);
const PayrollMasterDetails = lazy(() =>
  import("../Components/payroll/payrollMasterDetails")
);
const PayrollProfile = lazy(() =>
  import("../Components/payroll/PayrollProfile")
);
const CreateUpdateEmployeeDeductionsMaster = lazy(() =>
  import(
    "../Components/payroll/component/EmployeeDeductionMaster/CreateUpdateEDM"
  )
);
const EmployeeDeductionPlanMaster = lazy(() =>
  import("../Components/EmployeeDeductionMaster/index")
);
const MasterDetails = lazy(() => import("../Components/payroll/index"));
const EmployeeDeduction = lazy(() =>
  import("../Components/EmployeeDeduction/index")
);

const EmpDetails = lazy(() => import("../Components/AdvanceSearch"));
const PayrollWorkTime = lazy(() =>
  import("../Components/payroll/payrollWorkTime")
);
const GG1Details = lazy(() => import("../Components/CGITrackingNew/details"));
const Workflow = lazy(() => import("../Components/Workflow"));
const ManageWorkflow = lazy(() =>
  import("../Components/Workflow/ManageWorkflow")
);
const WorkflowConfiguration = lazy(() =>
  import("../Components/Workflow/WorkflowConfiguration")
);

const DashboardChart = lazy(() =>
  import("../Components/DashboardChart/Default")
);
// import Default from "";
const Default = lazy(() => import("../Components/Dashboard/Default")); // import Default from "";
const GG1List = lazy(() => import("../Components/CGITrackingNew/GG1List"));
const GG1Request = lazy(() =>
  import("../Components/CGITrackingNew/GG1Request")
);

//Drug Testing

const EmployeeLeaveShareForm = lazy(() =>
  import("../Components/EMR/EmployeeLeaveShare/EmployeeLeaveShareForm")
);
const CreateEmployeeLeaveShare = lazy(() =>
  import("../Components/EMR/EmployeeLeaveShare/CreateEmployeeLeaveShare")
);

// const PerformanceEvalution = lazy(() =>
//   import("../Components/EMR/PerformanceEvaluation")
// );
const CreatePerformanceEvalution = lazy(() =>
  import("../Components/EMR/PerformanceEvaluation/CreatePerformanceEvaluation")
);

const PerformanceEvalutionAppeal = lazy(() =>
  import("../Components/EMR/PerformanceEvaluationAppeal")
);
const CreatePerformanceEvalutionAppeal = lazy(() =>
  import(
    "../Components/EMR/PerformanceEvaluationAppeal/CreatePerformanceEvaluationAppeal"
  )
);

const CreateOutsideEmploymentRecord = lazy(() =>
  import(
    "../Components/EMR/OutsideEmploymentRecord/CreateOutsideEmploymentRecord"
  )
);

const EMRTrainingLog = lazy(() => import("../Components/EMR/EMRTrainingLog"));
const CreateEMRTrainingLog = lazy(() =>
  import("../Components/EMR/EMRTrainingLog/CreateEMRTrainingLog")
);

const AdverseAction = lazy(() => import("../Components/EMR/AdverseAction"));
const CreateAdverseAction = lazy(() =>
  import("../Components/EMR/AdverseAction/CreateAdverseAction")
);

const GrievanceRequest = lazy(() =>
  import("../Components/EMR/GrievanceRequest")
);
const CreateGrievanceRequest = lazy(() =>
  import("../Components/EMR/GrievanceRequest/CreateGrievanceRequest")
);

const SpecialMedicalEvaluation = lazy(() =>
  import("../Components/EMR/SpecialMedicalEvaluation")
);
const CreateSpecialMedicalEvaluation = lazy(() =>
  import(
    "../Components/EMR/SpecialMedicalEvaluation/CreateSpecialMedicalEvaluation"
  )
);

const CollectiveBargainingAgreementRequest = lazy(() =>
  import("../Components/EMR/CollectiveBargainingAgreementRequest")
);
const CreateCollectiveBargainingAgreementRequest = lazy(() =>
  import(
    "../Components/EMR/CollectiveBargainingAgreementRequest/CreateCollectiveBargainingAgreementRequest"
  )
);

const LongTermDisability = lazy(() =>
  import("../Components/EMR/LongTermDisability")
);
const CreateLongTermDisability = lazy(() =>
  import("../Components/EMR/LongTermDisability/CreateLongTermDisability")
);

const ReduceWorkHourRecord = lazy(() =>
  import("../Components/EMR/ReduceWorkHourRecord")
);
const CreateReduceWorkHourRecord = lazy(() =>
  import("../Components/EMR/ReduceWorkHourRecord/CreateReduceWorkHourRecord")
);
// const CreateNPATransactions = lazy(() =>
//   import("../Components/Records/NPAForms/NewCreateTransactions")
// );
const Inprogress = lazy(() => import("../Components/Inprogress/index"));

const Charts = lazy(() => import("../Components/Charts"));

export const routes = [
  {
    path: `${process.env.REACT_APP_PREFIX_URL}silentrenew`,
    auth: ["user", "HRAdmin", "DepartmentAdmin"],
    Component: <SilentRenewComponent />,
  },
  {
    path: `${process.env.REACT_APP_PREFIX_URL}activities`,
    Component: <ActivityList />,
  },
  {
    path: `${process.env.PUBLIC_URL}`,
    Component: <LoadingDashboard />,
  },

  {
    path: `${process.env.PUBLIC_URL}/dashboard/ecommerce`,
    Component: <Ecommerce />,
  },
  {
    path: `${process.env.PUBLIC_URL}/dashboard/employee`,
    Component: <Employee />,
  },

  {
    path: `${process.env.PUBLIC_URL}/master-detail`,
    // Component: <PayrollMasterDetails />,
    Component: <MasterDetails />,
  },

  {
    path: `${process.env.PUBLIC_URL}/master-detail/:employeeID`,
    Component: <MasterDetails />,
  },

  //   { path: `${process.env.PUBLIC_URL}/chat`, Component: <ChatAppContain /> },
  {
    path: `${process.env.PUBLIC_URL}/share`,
    Component: <LeaveShare />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leaveapplication`,
    Component: <LeaveApplicationWithFormik />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employ-verification`,
    Component: <EmployeeVerificationList />,
  },
  {
    path: `${process.env.PUBLIC_URL}/signature-management`,
    Component: <EmployeeDigitalSignatureMgmt />,
  },
  // { path: `${process.env.PUBLIC_URL}/leave/:id`, Component: <LeaveShare /> },
  {
    path: `${process.env.PUBLIC_URL}/outside-employment`,
    Component: <OutsideEmploymentWithFormik />,
  },
  {
    path: `${process.env.PUBLIC_URL}/outside-employment/:id`,
    Component: <OutsideEmploymentWithFormik />,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/outside-employment/:id/`,
  //   Component: <OutsideEmploymentWithFormik />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/payroll-work/:id`,
    Component: <PayrollWorkTime />,
  },

  {
    path: `${process.env.PUBLIC_URL}/performance-evaluation`,
    Component: <PerformanceEvalutionList />,
    exact: true,
  },
  {
    path: `${process.env.PUBLIC_URL}/performance-evaluation/:employeeid`,
    Component: <PerformanceEvaluation />,
  },

  {
    path: `${process.env.PUBLIC_URL}/performance-evaluation/:employeeid/:id`,
    Component: <PerformanceEvaluation />,
  },

  {
    path: "/online-recruitment",
    exact: true,
    Component: <OnlineRecruitment />,
    _roles: ["HRAdmin", "Developer"],
  },
  {
    path: "/online-recruitment/apply-job/:id",
    Component: <JobApplicationFormData />,
    exact: true,
    _roles: ["HRAdmin", "Developer"],
  },
  {
    path: "/online-recruitment/apply/:id/applied",
    Component: <RecruitmentFormData />,
    exact: true,
    _roles: ["HRAdmin", "Developer"],
  },

  {
    path: "/timesheet",
    Component: <TimesheetMain />,
    exact: true,
    _roles: ["HRAdmin", "Developer", "user"],
  },

  {
    path: "/online-recruitment/edit/:id",
    Component: <RecruitmentFormData />,
    exact: true,
    _roles: ["HRAdmin", "Developer"],
  },
  {
    path: "/online-recruitment/my-application",
    exact: true,
    Component: <MyApplications />,
    _roles: ["HRAdmin", "Developer"],
  },
  {
    path: "/employee-master",
    exact: true,
    Component: <EmpDetails />,
    // _roles: ["Developer"],
  },

  {
    path: "/advance-search",
    exact: true,
    Component: <EmpDetails />,
  },
  {
    path: `${process.env.REACT_APP_PREFIX_URL}silentrenew`,
    roles: ["user", "HRAdmin", "DepartmentAdmin"],
    Component: <SilentRenewComponent />,
  },

  {
    // path: `${process.env.PUBLIC_URL}/dashboard/default`,
    path: `/dashboard/default`,
    _roles: [
      "Developer",
      "user",
      "HRAdmin",
      "DepartmentAdmin",
      "reviewer",
      "appointingAuthority",
      "SuperUser",
    ],
    Component: <Default />,
  },
  {
    // path: `${process.env.PUBLIC_URL}/dashboard/default`,
    path: `/dashboard/default`,
    roles: ["Analyst"],
    Component: <DashboardChart />,
  },

  {
    path: `${process.env.PUBLIC_URL}/dashboard/employee`,
    Component: <Employee />,
  },
  {
    path: `${process.env.PUBLIC_URL}/payroll-profile`,
    Component: <PayrollProfile />,
  },
  {
    path: `${process.env.PUBLIC_URL}/payroll-profile/add-deduction/:employeeId/new`,
    Component: <CreateUpdateEmployeeDeductionsMaster />,
  },
  {
    path: `${process.env.PUBLIC_URL}/payroll-profile/add-deduction/new`,
    Component: <CreateUpdateEmployeeDeductionsMaster />,
  },
  {
    path: `${process.env.PUBLIC_URL}/payroll-profile/deduction-plan/new`,
    Component: <EmployeeDeductionPlanMaster />,
  },
  {
    path: `${process.env.PUBLIC_URL}/payroll-profile/deduction-plan/:id`,
    Component: <EmployeeDeductionPlanMaster />,
  },
  // master details
  {
    path: `${process.env.PUBLIC_URL}/master-detail`,
    Component: <PayrollMasterDetails />,
  },

  {
    path: `${process.env.PUBLIC_URL}/employeecreate-gg1/:ssn`,
    Component: <CreateEmployeeGG1 />,
    _roles: ["Developer", "HRAdmin"],
  },
  {
    path: `${process.env.PUBLIC_URL}/employeecreate-gg1`,
    Component: <CreateEmployeeGG1 />,
    _roles: ["Developer", "HRAdmin"],
  },

  { path: `${process.env.PUBLIC_URL}/chat`, Component: <ChatAppContain /> },
  // {
  //   path: `${process.env.PUBLIC_URL}/leaveapplication/:employeeID/:leaveid`,
  //   Component: <LeaveApplicationWithFormik />,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/leaveapplication/new`,
  //   Component: <LeaveApplicationWithFormik />,
  // },
  {
    path: `${process.env.PUBLIC_URL}/leaveapplication/:leaveid`,
    Component: <LeaveApplicationWithFormik />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leave/leaveShare`,
    Component: <LeaveShare />,
  },
  // leave share by id
  {
    path: `${process.env.PUBLIC_URL}/leaveShare/:leave/:LeaveShareID`,
    Component: <LeaveShare />,
  },

  {
    path: `${process.env.PUBLIC_URL}/leave-share-management`,
    Component: <LeaveShareManagement />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leave-share-management/recipient-form`,
    Component: <RecipientForm />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leave-share-management/select-recipint`,
    Component: <SearchRecipientDonor />,
  },
  {
    path: `${process.env.PUBLIC_URL}/leave-share-management/requested-recipint`,
    Component: <RequestedRecipient />,
  },

  {
    path: `${process.env.PUBLIC_URL}/outside-employment`,
    Component: <OutsideEmploymentWithFormik />,
  },
  {
    path: `${process.env.PUBLIC_URL}/employeedeductionmaster`,
    Component: <EmployeeDeduction />,
  },
  {
    path: `${process.env.PUBLIC_URL}/outside-employment/:id`,
    Component: <OutsideEmploymentWithFormik />,
  },
  // {
  //   path: `${process.env.PUBLIC_URL}/performance-evaluation`,
  //   Component: <PerformanceEvaluation />,
  //   _roles: [
  //     "HRAdmin",
  //     "user",
  //     "Developer",
  //     "supervisor",
  //     "reviewer",
  //     "appointingAuthority",
  //   ],
  //   // exact: true,
  // },
  // {
  //   path: `${process.env.PUBLIC_URL}/performance-evaluation/:employeeid`,
  //   Component: <PerformanceEvaluation />,
  //   _roles: [
  //     "HRAdmin",
  //     "Developer",
  //     "supervisor",
  //     "user",
  //     "reviewer",
  //     "appointingAuthority",
  //   ],
  //   // exact: true,
  // },
  {
    path: "/online-recruitment",
    exact: true,
    Component: <OnlineRecruitment />,
    _roles: ["HRAdmin", "Developer"],
  },
  {
    path: "/online-recruitment/apply/:id",
    Component: <RecruitmentFormData />,
    exact: true,
    _roles: ["HRAdmin", "Developer"],
  },
  {
    path: "/online-recruitment/edit/:id",
    Component: <RecruitmentFormData />,
    exact: true,
    _roles: ["HRAdmin", "Developer"],
  },
  // {
  //   path:"/popup",
  //   Component:<NPAVIEWPrint/>,
  //   exact: true,
  //   _roles: ["HRAdmin", "Developer"],
  // },
  {
    path: "/online-recruitment/my-application",
    exact: true,
    Component: <MyApplications />,
    _roles: ["HRAdmin", "Developer"],
  },

  {
    path: "/workflow",
    Component: <Workflow />, //React.lazy(() => import("../Components/ins-enrollment/benefitMasterDetail")),
    exact: true,
    _roles: ["Developer"],
  },

  {
    path: "/sidebar",
    Component: <SideBar />, //React.lazy(() => import("../Components/ins-enrollment/benefitMasterDetail")),
    exact: true,
    _roles: ["Developer"],
  },
  {
    path: "/sidebar/create",
    Component: <CreateMenu />, //React.lazy(() => import("../Components/ins-enrollment/benefitMasterDetail")),
    exact: true,
    _roles: ["Developer"],
  },
  {
    path: "/sidebar/update/:id",
    Component: <CreateMenu />, //React.lazy(() => import("../Components/ins-enrollment/benefitMasterDetail")),
    exact: true,
    _roles: ["Developer"],
  },
  {
    path: "/sidebar/submenu/:menuid",
    Component: <CreateMenu />, //React.lazy(() => import("../Components/ins-enrollment/benefitMasterDetail")),
    exact: true,
    _roles: ["Developer"],
  },

  {
    path: "/inprogress",
    Component: <Inprogress />,
    exact: true,
    // _roles: ["Developer"],
  },

  // {
  //   path: "/jobannouncement/new",
  //   Component: <JobAnnouncementAddOrUpdate />,
  //   exact: true,
  //   _roles: ["Developer"],
  // },
  // {
  //   path: "/jobannouncement/:ANNOUNCEMENT_ID",
  //   Component: <JobAnnouncementAddOrUpdate />,
  //   exact: true,
  //   _roles: ["Developer"],
  // },

  {
    path: "/unauthorized",
    Component: <UnAuthorized />,
    exact: true,
    layout: "none",
  },
  {
    path: "/withoutlogin",
    Component: <WithoutLogin />,
    exact: true,
    layout: "none",
  },
  {
    path: "/logout",
    Component: <Logout />,
    exact: true,
    layout: "none",
  },

  {
    path: "/sharess",
    Component: <EmployeeLeaveShareForm />,
    exact: true,
    _roles: ["Developer"],
  },
  // {
  //   path: "/employee-leave-share",
  //   Component: <CreateEmployeeLeaveShare />,
  //   exact: true,
  //   roles: ["HRAdmin"],
  // },
  {
    path: "/employee-leave-share/new",
    Component: <CreateEmployeeLeaveShare />,
    exact: true,
    _roles: ["Developer"],
  },
  {
    path: "/employee-performance-evaluation",
    Component: <CreatePerformanceEvalution />,
    exact: true,
    _roles: ["HRAdmin", "Developer"],
  },
  {
    path: "/employee-performance-evaluation/new",
    Component: <CreatePerformanceEvalution />,
    exact: true,
    _roles: ["HRAdmin", "Developer"],
  },
  {
    path: "/performance-evaluation-appeal",
    Component: <PerformanceEvalutionAppeal />,
    exact: true,
    _roles: ["HRAdmin", "Developer"],
  },
  {
    path: "/performance-evaluation-appeal/new",
    Component: <CreatePerformanceEvalutionAppeal />,
    exact: true,
    _roles: ["HRAdmin", "Developer"],
  },
  {
    path: "/performance-evaluation-appeal/:id",
    Component: <CreatePerformanceEvalutionAppeal />,
    exact: true,
    _roles: ["HRAdmin", "Developer"],
  },
  {
    path: "/outside-employment-record",
    Component: <CreateOutsideEmploymentRecord />,
    exact: true,
    _roles: ["Developer"],
  },
  {
    path: "/outside-employment-record/new",
    Component: <CreateOutsideEmploymentRecord />,
    exact: true,
    _roles: ["Developer"],
  },

  {
    path: "/employeeVerification/:employeeID",
    Component: <EmployeeVerification />,
    exact: true,
    layout: "none",
  },
  {
    path: "/Employee-Earnings",
    Component: <EmployeeEarning />,
    exact: true,
    _roles: ["Developer", "user"],
  },
  {
    path: "/Employee-All-Earnings",
    Component: <AllEarnings />,
    exact: true,
    _roles: ["Developer", "user"],
  },

  { path: `mainmenu`, Component: <MainMenu /> },
];
